import Axios from "axios"
import auth from "@/auth"
import https from "https"

const agent = new https.Agent({
  rejectUnauthorized: false
})

export default {
  getUser(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getUser", { email: _email }, config)
  },
  getZones(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getZones", { email: _email }, config)
  },
  getZonesEx(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getZonesEx", { email: _email }, config)
  },
  getZone(_deviceID) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getZone", { deviceID: _deviceID }, config)
  },
  getBoros() {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getBoros", {}, config)
  },
  switchZone(_zoneID, _email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/switchZone", { zoneID: _zoneID, email: _email }, config)
  },
  addZone(_deviceID, _name, _gsd_id, _boro_id, _next_billing_at) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/addZone", { deviceID: _deviceID, name: _name, gsd_id: _gsd_id, boro_id: _boro_id, next_billing_at: _next_billing_at }, config)
  },
  updateZone(_deviceID, _name, _gsd_id, _boro_id, _next_billing_at) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/updateZone", { deviceID: _deviceID, name: _name, gsd_id: _gsd_id, boro_id: _boro_id, next_billing_at: _next_billing_at }, config)
  },
  deleteZone(_deviceID) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/deleteZone", { deviceID: _deviceID }, config)
  },
  uploadZoneImage(_deviceID, image) {
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        httpsAgent: agent,
        "Content-Type": "multipart/form-data"
      }
    }
    var bodyFormData = new FormData()
    bodyFormData.set("deviceID", _deviceID)
    bodyFormData.append("image", image)
    return Axios.post("/uploadZoneImage", bodyFormData, config)
  },
  getUsers() {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getUsers", {}, config)
  },
  addUser(_email, _role, _zoneId, _password) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/addUser", {
      email: _email,
      role: _role,
      zoneId: _zoneId,
      password: _password
    }, config)
  },
  addExistingUserToZone(_email, _zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/addExistingUserToZone", {
      email: _email,
      zoneId: _zoneId
    }, config)
  },
  deleteUser(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/deleteUser", {
      email: _email.toLowerCase()
    }, config)
  },
  deleteUserAccessToZone(_email, _zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/deleteUserAccessToZone", {
      email: _email.toLowerCase(),
      zoneId: _zoneId
    }, config)
  },
  getUserZoneAccess(_email) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getUserZoneAccess", {
      email: _email.toLowerCase()
    }, config)
  },
  getZoneUsers(_zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getZoneUsers", {
      zoneId: _zoneId
    }, config)
  },
  getZoneLog(_zoneId) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getZoneLog", {
      zoneID: _zoneId
    }, config)
  },
  getUserBillingDue(_user) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/getUserBillingDue", {
      user: _user
    }, config)
  },
  updateUserNotifications(_email, _notifications) {
    var config = {
      headers: { Authorization: "Bearer " + localStorage.getItem("access_token"), httpsAgent: agent }
    }
    return Axios.post("/updateUserNotifications", {
      email: _email,
      notifications: _notifications
    }, config)
  }
}



// WEBPACK FOOTER //
// ./src/api/user.service.js